(ns dashboard.views.user-preferences.view
  (:require [dashboard.components.breadcrumbs :as breadcrumbs]
            [dashboard.subs :as common-subs]
            [dashboard.views.user-preferences.events :as events]
            [io.repliance.schemas.user-preferences :as preferences-schema]
            [malli.core :as m]
            [re-frame.core :as rf]
            [reitit.frontend.easy :as rfe]))

(def view-id :user/preferences)

(defn breadcrumbs []
  [{:href (rfe/href :route.view/home)
    :label "Dashboard"}
   {:href (rfe/href view-id)
    :label "User preferences"
    :active? true}])

(defn View []
  (let [preferences @(rf/subscribe [::common-subs/user-preferences])]
    [:div
     [breadcrumbs/breadcrumbs {:items (breadcrumbs)}]
     [:div.section
      [:ul
       (for [[preference-key {:ui/keys [label] :keys [default]} schema] (m/children preferences-schema/UserPreferences)]
         [:li {:key preference-key}
          [:label.checkbox
           (case (m/type schema)
             :boolean
             (let [value (get preferences preference-key default)]
               [:input.mr-2
                {:type "checkbox"
                 :checked value
                 :on-change #(rf/dispatch [::events/save-user-preferences (assoc preferences preference-key (not value))])}])
             nil)
           label]])]]]))
